"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditElements = exports.PopoverContentContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.PopoverContentContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  padding: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  padding: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.concrete;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
exports.EditElements = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var templateObject_1, templateObject_2;
